module.exports = __webpack_public_path__ + "static/img/zptp1.4e87591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/zptp1.jpg
// module id = TtDo
// module chunks = 11